
import { BarChart2, GitBranch, Sigma, Share2, Database, Users, Clock, ShieldCheck } from "lucide-react";
import AnimatedSection from "./AnimatedSection";

const features = [
  {
    icon: <GitBranch className="h-10 w-10 text-primary" />,
    title: "Visual Workflow Builder",
    description: "Create powerful data workflows by connecting nodes in an intuitive drag-and-drop interface - no coding required."
  },
  {
    icon: <Sigma className="h-10 w-10 text-primary" />,
    title: "Intuitive Bayesian Modelling",
    description: "Build sophisticated Bayesian models without complex coding through our user-friendly visual interface."
  },
  {
    icon: <BarChart2 className="h-10 w-10 text-primary" />,
    title: "Interactive Visualisations",
    description: "Turn your data into compelling visualisations with pre-built chart nodes that anyone can configure."
  },
  {
    icon: <Database className="h-10 w-10 text-primary" />,
    title: "Multiple Data Sources",
    description: "Connect to various data sources including SQL databases, CSV files, APIs, and spreadsheets with simple node connections."
  },
  {
    icon: <Users className="h-10 w-10 text-primary" />,
    title: "Team Collaboration",
    description: "Share workflows and insights with team members to foster collaborative decision making across departments."
  },
  {
    icon: <Clock className="h-10 w-10 text-primary" />,
    title: "Automated Workflows",
    description: "Schedule your workflows to run automatically and keep your dashboards and reports updated with fresh data."
  }
];

const Features = () => {
  return (
    <section id="features" className="section-padding bg-secondary/50">
      <div className="container-narrow">
        <AnimatedSection className="text-center mb-16">
          <div className="inline-block px-3 py-1 mb-6 rounded-full bg-primary/10 text-primary text-xs font-medium tracking-wider">
            FEATURES
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-bold tracking-tight mb-6">
            Visual Node-Based Workflows
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Our platform combines the power of intuitive node-based workflows with sophisticated Bayesian analysis capabilities, making complex data analysis accessible without writing a single line of code.
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <AnimatedSection 
              key={index} 
              delay={index * 100}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300 border border-border/50"
            >
              <div className="mb-5 p-3 inline-block rounded-xl bg-primary/10">
                {feature.icon}
              </div>
              <h3 className="text-xl font-display font-semibold mb-3">
                {feature.title}
              </h3>
              <p className="text-muted-foreground">
                {feature.description}
              </p>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
